import {DomainEvent} from './DomainEvent';
import {CompetitionSeason} from '../resources/CompetitionSeason';

export class CompetitionSeasonActivated extends DomainEvent<CompetitionSeason> {}
